import { useEffect, useState } from 'react';

import styles from './index.module.scss';

interface switchPorps {
  id: string;
  isChecked: boolean;
  onCheckChange: (value: boolean) => void;
  className?: string;
}

const Switch = ({ id, isChecked, onCheckChange, className }: switchPorps) => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    onCheckChange(event.target.checked);
  };

  return (
    <div className={`${styles.switch} ${className}`}>
      <label htmlFor={id}></label>
      <input
        id={id}
        value={id}
        checked={checked}
        type="checkbox"
        onChange={onChangeHandler}
      />
    </div>
  );
};

export default Switch;
